'use client';

import { useQuery } from '@tanstack/react-query';
import { useApiClient } from '../../../contexts/ApiContext';
import { queryKeys } from '../../../lib/queryClient';
import type { AchievementStats } from '../../../services/generated/Api';

export type { AchievementStats, AchievementStats as AchievementStatsResponse };

export class AchievementStatsNotFoundError extends Error {
  constructor() {
    super('achievement stats not found');
    this.name = 'AchievementStatsNotFoundError';
  }
}

export function useAchievementStats(key?: string, options?: { enabled?: boolean }) {
  const api = useApiClient();
  return useQuery({
    queryKey: queryKeys.achievementsStats(key),
    queryFn: async (): Promise<AchievementStats> => {
      try {
        return await api.api.achievementsControllerGetStats(key as string);
      } catch (err) {
        if ((err as Response | undefined)?.status === 404) throw new AchievementStatsNotFoundError();
        throw err;
      }
    },
    enabled: !!key && (options?.enabled ?? true),
    staleTime: 15 * 60 * 1000,
  });
}
